var _circle, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoReqHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_3123_17299)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 57H19.5C18 57 17 56 17 54.5C17 53 18 52 19.5 52H37C38.5 52 39.5 53 39.5 54.5C39.5 56 38.5 57 37 57Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5361 59.0712L49.9295 48.4646C48.8688 47.4039 48.8688 45.9897 49.9295 44.929C50.9902 43.8684 52.4044 43.8684 53.465 44.929L64.0716 55.5356C65.1323 56.5963 65.1323 58.0105 64.0716 59.0712C63.011 60.1318 61.5968 60.1318 60.5361 59.0712Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9293 59.0712C48.8687 58.0105 48.8687 56.5963 49.9293 55.5356L60.5359 44.929C61.5966 43.8684 63.0108 43.8684 64.0715 44.929C65.1321 45.9897 65.1321 47.4039 64.0715 48.4646L53.4649 59.0712C52.4042 60.1318 50.99 60.1318 49.9293 59.0712Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44.5H19.5C18 44.5 17 43.5 17 42C17 40.5 18 39.5 19.5 39.5H47C48.5 39.5 49.5 40.5 49.5 42C49.5 43.5 48.5 44.5 47 44.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 32H19.5C18 32 17 31 17 29.5C17 28 18 27 19.5 27H47C48.5 27 49.5 28 49.5 29.5C49.5 31 48.5 32 47 32Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3123_17299",
    x1: 42,
    y1: 84,
    x2: 42,
    y2: 0.0000104464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReqHistory);
export default __webpack_public_path__ + "static/media/no-req-history.a79ebb044e3befa0beef8eccdd9592b9.svg";
export { ForwardRef as ReactComponent };